import { Component, OnInit, Input } from '@angular/core';

@Component( {
    selector: 'ridango-table',
    templateUrl: './table.component.html',
    styleUrls: [ './table.component.css' ]
} )
export class TableComponent implements OnInit {
    @Input() header = [];
    @Input() isTable;
    
    constructor() { }

    ngOnInit () {
    }

}
